import { render, staticRenderFns } from "./ServicesCategoriesDetails.vue?vue&type=template&id=f7a68d64"
import script from "./ServicesCategoriesDetails.vue?vue&type=script&lang=js"
export * from "./ServicesCategoriesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports